import React, {Component} from 'react';
import {observer} from 'mobx-react';

import Field from 'lib/struct/form/fields/Field';
import Select from 'lib/struct/form/Select';
import InlineCode from 'lib/struct/inlines/InlineCode';
import Icon from 'lib/struct/icon/Icon';
import * as OutputHook from 'settings/constant/OutputHook';

import styles from './GeneralSettings.less';

const bool_options = [{
	label: 'Включён',
	value: '1',
},{
	label: 'Выключен',
	value: '0',
},];

@observer export default class GeneralSettings extends Component {
	render() {
		/** @type {SettingsContext} */
		const context = this.props.context;
		const plugin_settings = context.current_plugin_settings;

		return (
			<div>
				{!plugin_settings ? (
					<div>
						<Icon name='loading' />
					</div>
				) : (
					<>
						<Field label='Статус плагина'>
							<Select
								options={bool_options}
								value={plugin_settings.is_enabled ? '1' : '0'}
								onChange={e => context.updateCurrentPluginSettingsValue('is_enabled', e.target.value === '1')}
							/>
						</Field>

						<Field label='Использовать стандартный хук для вывода'>
							<Select
								options={OutputHook.control_options}
								value={plugin_settings.output_wa_hook}
								onChange={e => context.updateCurrentPluginSettingsValue('output_wa_hook', e.target.value)}
							/>

							{plugin_settings.output_wa_hook === OutputHook.NONE && (
								<div className={styles['code-helper__block']}>
									Для размещения в <b>карточке товара</b> используйте хелпер
									<InlineCode className={styles['code-helper__code']}>
										{'{'}shopProductgroupViewHelper::getGroupsBlock($product.id){'}'}
									</InlineCode>
								</div>
							)}

							<div className={styles['code-helper__block']}>
								Для размещения в <b>категориях</b> используйте хелпер
								<InlineCode className={styles['code-helper__code']}>
									{'{'}shopProductgroupViewHelper::getCategoryProductBlock($product.id){'}'}
								</InlineCode>
							</div>
						</Field>
					</>
				)}
			</div>
		);
	}
}
